import { useState } from 'react';
import { faqs, siteStats } from '@/mocks/home';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="w-1 h-5 rounded-full bg-accent-500"></div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
              常见问题
            </h2>
          </div>
          <p className="text-sm text-foreground-500">关于91影视，您想了解的都在这</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="space-y-3">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-background-100 rounded-xl border border-background-200/50 overflow-hidden cursor-pointer"
                >
                  <button
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  >
                    <span className="text-sm font-medium text-foreground-100 pr-4">
                      {faq.question}
                    </span>
                    <i
                      className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    ></i>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      openIndex === index ? 'max-h-96' : 'max-h-0'
                    }`}
                  >
                    <p className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-background-100 rounded-xl border border-background-200/50 p-6">
            <h3 className="text-base font-semibold text-foreground-100 mb-4">平台数据</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between py-3 border-b border-background-200/50">
                <span className="text-sm text-foreground-500">电影资源</span>
                <span className="text-sm font-semibold text-foreground-100">
                  {siteStats.totalMovies.toLocaleString()}+
                </span>
              </div>
              <div className="flex items-center justify-between py-3 border-b border-background-200/50">
                <span className="text-sm text-foreground-500">电视剧资源</span>
                <span className="text-sm font-semibold text-foreground-100">
                  {siteStats.totalTVShows.toLocaleString()}+
                </span>
              </div>
              <div className="flex items-center justify-between py-3 border-b border-background-200/50">
                <span className="text-sm text-foreground-500">动漫资源</span>
                <span className="text-sm font-semibold text-foreground-100">
                  {siteStats.totalAnime.toLocaleString()}+
                </span>
              </div>
              <div className="flex items-center justify-between py-3 border-b border-background-200/50">
                <span className="text-sm text-foreground-500">综艺资源</span>
                <span className="text-sm font-semibold text-foreground-100">
                  {siteStats.totalVariety.toLocaleString()}+
                </span>
              </div>
              <div className="flex items-center justify-between py-3 border-b border-background-200/50">
                <span className="text-sm text-foreground-500">日访问用户</span>
                <span className="text-sm font-semibold text-accent-400">
                  {siteStats.dailyVisitors}
                </span>
              </div>
              <div className="flex items-center justify-between py-3">
                <span className="text-sm text-foreground-500">月活跃用户</span>
                <span className="text-sm font-semibold text-accent-400">
                  {siteStats.monthlyActive}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}